import { Box, Chip, Typography } from "@mui/material"
import { Comparison } from "routes/schedule/compare/lib/diff3"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"

export function PreviewField({ label, oldText, newText, hasChange }) {
    if (!oldText && !newText) return null
    return (
        <Box>
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                {label}
                <If truthy={hasChange}>
                    {" "}
                    <Chip label="changed" size="small" color="success" sx={{ ml: 0.5 }} />
                </If>
            </Typography>
            <Box
                className="styled-bullets"
                sx={{
                    border: "1px solid",
                    borderColor: hasChange ? "success.light" : "action.disabled",
                    borderRadius: 1,
                    p: 1.5,
                    fontSize: "0.875rem",
                }}
            >
                <If truthy={hasChange}>
                    <Comparison text={newText ?? ""} original={oldText ?? ""} other={oldText ?? ""} />
                    <Else>
                        {/* Content is sanitized server-side before storage */}
                        <Box dangerouslySetInnerHTML={{ __html: newText ?? "" }} />
                    </Else>
                </If>
            </Box>
        </Box>
    )
}
